module.exports = __webpack_public_path__ + "img/logo_blue_light.f7acce28.svg";